import React, { useRef } from "react";
import { Radar } from "@ant-design/charts";

const basic = {
	xField: "key",
	yField: "value",
	xAxis: {
		line: null,
		tickLine: null,
		grid: {
			line: {
				style: {
					lineDash: null,
				},
			},
		},
	},

	meta: {
		value: {
			alias: "value",
			min: 0,
			nice: true,
			formatter: (v) => Number(v).toFixed(2),
		},
	},
	autoFit: true,
	appendPadding: 10,
};

const area = {};
const point = {};
const smooth = true;
const seriesField = "type";

export default function RadarChart(chartData = [], chartConfig = {}) {
	const config = {
		data: chartConfig.isMultiLine
			? chartData
			: chartData.map((d) => ({
					...d,
					value: Math.log(d.value),
			  })),
		...basic,
		seriesField: chartConfig.isMultiLine ? seriesField : false,
		area: chartConfig.area ? area : false,
		point: chartConfig.point ? point : false,
		smooth: chartConfig.smooth ? smooth : false,
	};
	const ref = useRef();

	return <Radar {...config} chartRef={ref} />;
}
